import { cn } from "@ui/lib/utils";

import { TransparencyCheckerboard } from "./TransparencyCheckerboard";

interface FlowTemplateResultImageProps {
  src: string;
  alt: string;
  className?: string;
}

/**
 * The generated-result preview: a checkerboard-backed, rounded square frame
 * holding the (xi-hosted) result image. Shared by the standalone
 * `BlockFlowTemplate` and the gallery modal so the frame styling lives in one
 * place.
 */
export function FlowTemplateResultImage({ src, alt, className }: FlowTemplateResultImageProps) {
  return (
    <div
      className={cn(
        "tw-relative tw-aspect-square tw-w-full tw-overflow-hidden tw-rounded-[20px] tw-border tw-border-black/10",
        className,
      )}
    >
      <TransparencyCheckerboard />
      {/* eslint-disable-next-line @next/next/no-img-element -- xi-hosted result URL; next/image would require host allowlisting */}
      <img src={src} alt={alt} className='tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-contain' />
    </div>
  );
}
